import {
  EquirectangularReflectionMapping,
  LinearSRGBColorSpace,
  Texture,
  TextureLoader,
} from "three";
import { EXRLoader } from "three/examples/jsm/loaders/EXRLoader.js";
import { HDRLoader } from "three/examples/jsm/loaders/HDRLoader.js";
import { logger } from "../../util/Logger";

/** Varsayılan IBL: F-kodlu env (`FFC6JX4TV8`), Photo Studio değil. */
export const DEFAULT_ENVIRONMENT_URL =
  "https://img-sugartech.mncdn.com/cdn.sugartech/mottobucket/FFC6JX4TV8.png";

function fileExtension(url: string): string {
  try {
    const path = new URL(url, "https://local.invalid").pathname;
    const base = path.split("/").pop() ?? "";
    const dot = base.lastIndexOf(".");
    return dot >= 0 ? base.slice(dot + 1).toLowerCase() : "";
  } catch {
    const clean = url.split("?")[0] ?? url;
    const dot = clean.lastIndexOf(".");
    return dot >= 0 ? clean.slice(dot + 1).toLowerCase() : "";
  }
}

/**
 * Load an equirect environment map. Supports `.hdr` / `.exr` (HDR) and
 * `.png` / `.jpg` / `.webp` (LDR) — PNG must not go through HDRLoader.
 */
export async function loadEnvironmentTexture(
  url: string,
): Promise<Texture | undefined> {
  if (!url) return undefined;

  const extension = fileExtension(url);
  let loader: TextureLoader | HDRLoader | EXRLoader;

  switch (extension) {
    case "exr":
      loader = new EXRLoader();
      break;
    case "hdr":
      loader = new HDRLoader();
      break;
    case "png":
    case "jpg":
    case "jpeg":
    case "webp":
      loader = new TextureLoader();
      break;
    default:
      logger.warn(
        `loadEnvironmentTexture: unknown extension "${extension}", using TextureLoader`,
      );
      loader = new TextureLoader();
      break;
  }

  try {
    const texture = (await loader.loadAsync(url)) as Texture;
    texture.mapping = EquirectangularReflectionMapping;
    texture.colorSpace = LinearSRGBColorSpace;
    return texture;
  } catch (err) {
    logger.error("loadEnvironmentTexture: failed", url, err);
    return undefined;
  }
}
